<template>
  <section>
    <social-header v-if="currentEnv" title="上传发票"></social-header>
    <!--上传发票tips-->
    <div class="upload-tips">
      <p>上传发票注意事项：</p>
      <p>1、发票姓名须与下单姓名完全一致</p>
      <p>2、发票经销商须是下单经销商中之一</p>
      <p>3、发票开票日期一定是在下单日期之后</p>
    </div>
    <!--上传发票tips-->
    <!--上传发票按钮-->
    <p class="upload-btn"><a href="javascript:;" title="" v-on:click="choose()" v-stat:click="{name:'choose'}"><span>+</span>上传发票</a></p>
    <!--上传发票按钮-->
    <!--上传发票图片占位符-->
    <div class="upload-img" v-show="choosed">
      <img v-bind:src="imgurl" alt="">
    </div>
    <!--上传发票图片占位符-->
    <div class="fixed-btn-bak"></div>
    <div class="fixed-btn" v-show="choosed">
      <a class="common-btn blue-big-btn " href="javascript:;" title="" v-on:click="submit()" v-stat:click="{name:'submit'}">提交</a>
    </div>
    <social-dialog v-bind:title="dialogTitle" v-bind:show="dialogShow"></social-dialog>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import SocialHeader from '../../components/social-header.vue'
import SocialDialog from '../../components/social-dialog.vue'
import Environment from '../../service/environment.service.js'
import {orderAPI} from '../../api'
import Dialog from '../../plugins/dialog.js'
import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

export default {
  components: {
    SocialHeader,
    SocialDialog
  },
  name: 'AccountOrderInvoice',
  data: function () {
    return {
      choosed: false,
      dialogShow: false,
      imgurl: '',
      originUrl: '',
      dialogTitle: '正在加载中'
    }
  },
  created: function () {
    changeDocumentTitle('上传发票')
    console.log(this.$route.params)
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo'
    }),
    currentEnv () {
      if (isWeiXin()) {
        return false
      } else if (isDingDing()) {
        return false
      } else {
        return true
      }
    }
  },
  methods: {
    choose: function () {
      let current = this
      // 选择微信图片
      if (window.entrance.name !== 'wx' && window.entrance.name !== 'mainapp') {
        Dialog.toast({title: '请在微信或主app环境中打开此页面', timeout: 1000})
        return false
      }
      Environment.chooseImage(function (data) {
        // 微信的id或者本地图片的物理地址
        current.originUrl = data.imgId
        // 微信的id（可以直接显示）或者app的base64图片信息
        current.imgurl = data.imgBase64 || data.imgId
        current.choosed = true
      })
    },
    // 提交
    submit: function () {
      const orderId = this.$route.params.orderId
      console.log('submit')
      let current = this
      current.dialogShow = true
      Environment.upload(this.originUrl, function (data) {
        let serverId = data.imgId // 返回图片的服务器端ID，只有微信才有
        let imgBase64 = data.imgBase64
        var request = orderAPI.addInvoice({orderId: orderId, wxMediaId: serverId, imgData: imgBase64})
        request.then(function (resp) {
          current.dialogShow = false
          if (resp.data.returnCode !== 0) {
            Dialog.toast({title: resp.data.message, timeout: 1500})
          } else {
            Dialog.toast({title: '提交成功', timeout: 1000})
            current.$router.go(-1)
          }
        })
      })
    }
  }
}
</script>
<style>
.upload-img{
  text-align: center;
}
.upload-img img{
  max-height: 10rem;
  max-width: 100%;
  width: auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/account/invoice.vue